import { Injectable } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const BREAKPOINT_CLASS_MAP: ReadonlyMap<string, string> = new Map([
	['(max-width: 320px)', 'xtra-sm-cust-screen'],
	['(max-width: 520px)', 'sm-cust-screen'],
]);

@Injectable({
	providedIn: 'root',
})
export class ScreenBreakpointService {
	constructor(breakpointObserver: BreakpointObserver) {
		const root: HTMLElement = document.documentElement;

		breakpointObserver
			.observe([...BREAKPOINT_CLASS_MAP.keys()])
			.pipe(takeUntilDestroyed())
			.subscribe((breakpointState: Partial<BreakpointState>) => {
				if (!breakpointState.breakpoints) {
					return;
				}

				const classesToAdd: string[] = [];
				const classesToRemove: string[] = [];

				for (const [breakpoint, htmlClass] of BREAKPOINT_CLASS_MAP) {
					if (breakpointState.breakpoints[breakpoint]) {
						classesToAdd.push(htmlClass);
					} else {
						classesToRemove.push(htmlClass);
					}
				}

				root.classList.add(...classesToAdd);
				root.classList.remove(...classesToRemove);
			});
	}
}
